var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.729 1.96051C10.8405 2.59257 10.4184 3.19531 9.78636 3.30676C9.1543 3.41821 8.55156 2.99617 8.44011 2.36411C8.32866 1.73204 8.7507 1.1293 9.38277 1.01785C10.0148 0.906399 10.6176 1.32844 10.729 1.96051Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0724 22.9643C13.3365 22.7414 14.1806 21.5359 13.9577 20.2718L9.37986 21.079C9.60276 22.3431 10.8082 23.1872 12.0724 22.9643Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59855 20.7411L20.621 17.9159L20.4192 16.7714C20.3824 16.563 20.2922 16.3774 20.1651 16.2262C19.9069 15.919 19.4965 15.7541 19.0729 15.8288L18.8831 15.8622L18.289 14.1811C18.1622 13.8223 18.0754 13.4506 18.0303 13.0728L17.6823 10.1636C17.2326 6.40366 13.7167 3.79347 9.98754 4.45102C6.25837 5.10858 3.84723 8.76387 4.71062 12.4508L5.37867 15.3036C5.46544 15.6741 5.51102 16.053 5.51459 16.4335L5.53132 18.2165L5.33941 18.2503C4.9158 18.325 4.58653 18.6204 4.44896 18.9974C4.38134 19.1827 4.36004 19.3877 4.39665 19.596L4.59855 20.7411ZM17.339 16.7245L7.27721 18.4987L7.25768 16.4172C7.2529 15.9083 7.19195 15.4016 7.07593 14.9061L6.40788 12.0534C5.77265 9.34078 7.5466 6.65149 10.2902 6.16771C13.0339 5.68393 15.6206 7.60432 15.9515 10.3706L16.2994 13.2798C16.3598 13.785 16.4759 14.2821 16.6454 14.7619L17.339 16.7245Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationRightIcon);
export default __webpack_public_path__ + "static/media/notification_right-icon.84eab49d774d1633f52792a762b9c0d4.svg";
export { ForwardRef as ReactComponent };